module.exports = __webpack_public_path__ + "static/media/scan2.7463b1d8.svg";